import { render, staticRenderFns } from "./VacanciesItem.vue?vue&type=template&id=807bfbf2&"
import script from "./VacanciesItem.vue?vue&type=script&lang=js&"
export * from "./VacanciesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports